import { Dropdown, ProgressBar } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import folderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { Dispatch, SetStateAction, useState } from 'react'
import { useIntl } from 'react-intl'
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { formatFileSize, getFileType } from '../../../../core/_util'
import { useAuth } from '../../../auth'
import { deleteSourceApi, sourceRetryApi, sourceSyncStatus } from '../../core/_requests'
import { toast } from 'react-toastify'
import { DeleteFileConfirmationModal } from '../../../stakeholders/components/delete-file-confirmation-modal'
import Lottie from 'lottie-react'
import animationData from '../../../../../media/loadingLottileData.json'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'
import { GrConnect } from 'react-icons/gr'
import { RecordSync } from '../../core/_constants'
import ThreadTitle from '../../../AI-banker/components/shortenString'

const AddedStorageCard = ({
  title,
  syncdate,
  folderPath,
  createdByEmail,
  createdByDate,
  storageIcon,
  storageSize,
  attachedSourceEmail,
  totalFiles,
  noOfSyncFiles,
  sourceId,
  syncEnabled,
  sourceName,
  fetchSources,
  isFolder,
  fetchStorageSize,
  isPlanLimitExceeded,
  isRetry,
  fetchIntervalSource,
  isReconnectSource,
  setIsModalActive,
  setIsReconnectClicked,
  setReconnectSourceIsClicked,
  setCurrentDocumentStep,
  setReconnectSourceIdIsClicked,
  setReconnectSourceNameIsClicked,
}: {
  title: string
  syncdate: string
  folderPath: string
  createdByEmail: string
  createdByDate: string
  storageIcon: string
  storageSize: string
  attachedSourceEmail: string
  totalFiles: number
  noOfSyncFiles: number
  sourceId: string
  syncEnabled: boolean
  sourceName: string
  isFolder: boolean
  fetchSources: () => void
  fetchStorageSize: () => void
  isPlanLimitExceeded: boolean
  isRetry: boolean
  fetchIntervalSource: () => void
  isReconnectSource: boolean
  setIsModalActive: Dispatch<SetStateAction<boolean>>
  setIsReconnectClicked: Dispatch<SetStateAction<boolean>>
  setReconnectSourceIsClicked: Dispatch<SetStateAction<RecordSync | null>>
  setCurrentDocumentStep: Dispatch<SetStateAction<number>>
  setReconnectSourceIdIsClicked: Dispatch<SetStateAction<string | null>>
  setReconnectSourceNameIsClicked: Dispatch<SetStateAction<string | null>>
}) => {
  const { formatMessage } = useIntl()
  const [isSyncEnabled, setIsSyncEnabled] = useState(syncEnabled)
  const { companyId } = useAuth()
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [syncToggleLoading, setSyncToggleLoading] = useState(false)
  const [isRetryLoading, setIsRetryLoading] = useState(false)
  const navigate = useNavigate()

  const deleteSource = async () => {
    setDeleteLoading(true)
    try {
      const {
        data: { success, errors },
      } = await deleteSourceApi(sourceId, companyId!)
      if (success) {
        toast.success(formatMessage({ id: 'Source deleted successfully' }))
        fetchSources()
        fetchStorageSize()
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setDeleteLoading(false)
      setDeleteShowModal(false)
    }
  }

  const handleSourceRetry = async () => {
    if (!companyId || !sourceId) return
    setIsRetryLoading(true)
    try {
      const {
        data: { success, errors },
      } = await sourceRetryApi(sourceId, companyId)
      if (success) {
        fetchIntervalSource()
        toast.success(formatMessage({ id: 'Source retried successfully' }))
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsRetryLoading(false)
    }
  }

  const handleToggleChange = async (event: any) => {
    if (!companyId || !sourceId) return
    setSyncToggleLoading(true)
    setIsSyncEnabled(event.target.checked)
    try {
      const {
        data: { success, errors },
      } = await sourceSyncStatus(sourceId, event.target.checked, sourceName, companyId!)
      if (success) {
        toast.success(
          formatMessage({ id: `Sync status is ${event.target.checked ? 'enabled' : 'disabled'}` })
        )
      } else {
        toast.error(errors[0])
        setIsSyncEnabled(false)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setSyncToggleLoading(false)
    }
  }

  return (
    <>
      <div className='p-4 bg-white rounded-2 mb-6'>
        <div className='mb-4'>
          <div className='d-flex flex-md-row flex-column justify-content-between gap-4'>
            <img src={storageIcon} alt='' width={48} height={48} className='order-2 order-md-1' />
            <div className='d-flex justify-content-end align-items-center gap-3 order-1 order-md-2'>
              <div className='d-flex gap-1 align-items-center justify-content-md-start justify-content-center badge badge-primary'>
                <img
                  src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-sync.svg')}
                  alt=''
                  width={20}
                  height={20}
                />
                <p className='mb-0 text-white font-weight-400'>{syncdate}</p>
              </div>

              {syncToggleLoading ? (
                <span className='indicator-label font-size-13 p-0'>
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                <label className='toggle m-0'>
                  <input
                    className='toggle__input'
                    name='toggle-input'
                    type='checkbox'
                    disabled={totalFiles !== 0 && noOfSyncFiles !== totalFiles && !isRetry}
                    checked={isSyncEnabled}
                    onChange={handleToggleChange}
                  />
                  <div className='toggle__fill'></div>
                </label>
              )}

              {isRetry && (
                <div
                  role='button'
                  className='p-3 cursor-pointer rounded-2 d-flex justify-content-center align-items-top height-36'
                  onClick={handleSourceRetry}
                  aria-disabled={isRetryLoading}
                >
                  <img
                    src={toAbsoluteUrl(
                      `/media/icons/RecordsKeeperAI/${isRetryLoading ? 'ic-file-sync.gif' : 'ic-file-sync.svg'
                      }`
                    )}
                    alt='sync'
                    width={18}
                    height={18}
                  />
                </div>
              )}

              {isReconnectSource && (
                <div
                  role='button'
                  className='p-3 cursor-pointer rounded-2 d-flex justify-content-center align-items-top height-36'
                  onClick={() => {
                    setIsReconnectClicked(true)
                    setCurrentDocumentStep(2)
                    setReconnectSourceIsClicked(sourceName as RecordSync)
                    setReconnectSourceIdIsClicked(sourceId)
                    setReconnectSourceNameIsClicked(title)
                    setIsModalActive(true)
                  }}
                >
                  <GrConnect size={20} color='#525556d4' />
                </div>
              )}

              <ToolTipUI
                margin='m-0'
                tooltipText={formatMessage({
                  id: 'Toggle on to enable automatic synchronization of this document. When enabled, RecordsKeeper.AI will automatically update this record when source files change.',
                })}
              />
              <div className='dropdown-container d-flex justify-content-center align-items-center'>
                <Dropdown>
                  <Dropdown.Toggle
                    className='btn btn-white table-three-dots dots-container d-flex justify-content-center'
                    style={{ height: '30px', width: '30px' }}
                  >
                    <img src={threeDots} alt='' className='three-dots-image' />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className='m-2' style={{ width: '130px' }}>
                    <Dropdown.Item
                      className='text-dark ps-5 rounded-top'
                      // onClick={() => setDeleteShowModal(true)}
                      onClick={() => {
                        navigate('sync-log')
                      }}
                    >
                      {formatMessage({ id: 'Sync Log' })}
                    </Dropdown.Item>
                    <Dropdown.Item
                      className='text-danger ps-5 rounded-bottom'
                      onClick={() => setDeleteShowModal(true)}
                    >
                      {formatMessage({ id: 'Delete' })}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex gap-1 align-items-center mb-4'>
          <img
            src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-storage.svg')}
            alt=''
            width={20}
            height={20}
          />
          <p className='mb-0 text-muted font-size-12'>{formatFileSize(storageSize as string)}</p>
        </div>

        <div>
          <div
            className={`badge p-2 mb-3  ${isPlanLimitExceeded || isRetry
              ? 'badge-light-warning'
              : totalFiles !== 0 && noOfSyncFiles === totalFiles
                ? 'badge-light-success'
                : 'badge-light-primary'
              }`}
          >
            {isPlanLimitExceeded || isRetry
              ? 'Syncing paused'
              : totalFiles !== 0 && noOfSyncFiles === totalFiles
                ? formatMessage({ id: 'Synced' })
                : formatMessage({ id: 'Storage Syncing...' })}
          </div>
          <div className='d-flex flex-md-row flex-column justify-content-between align-items-md-center align-items-start'>
            <div className='w-100 w-md-50'>
              {/* <h6 className='mb-2 font-size-16 w-100 mb-2 text-wrap'>{title.length >= 20 ? `${title.slice(0, 20)}...` : title}</h6> */}
              <h6 className='mb-2 font-size-16 w-100 mb-2'>
                <ThreadTitle title={title} fontSize='16' />
              </h6>
              {folderPath && (
                <div className='d-flex gap-1 align-items-center mb-md-7 mb-4'>
                  <img
                    src={isFolder ? folderIcon : getFileType(folderPath)}
                    alt=''
                    width={16}
                    height={16}
                  />
                  <p className='mb-0'>
                    <Link to={''} className='text-muted font-size-12'>
                      {folderPath}
                    </Link>
                    <span
                      onClick={() => {
                        navigator.clipboard.writeText(folderPath)
                        toast.success('Copied to clipboard')
                      }}
                    >
                      <img
                        src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-copy.svg')}
                        alt='copy icon'
                        className='ms-2 cursor-pointer'
                      />
                    </span>
                  </p>
                </div>
              )}
            </div>
            {totalFiles !== 0 && noOfSyncFiles === totalFiles && (
              <button
                className='mt-md-2 mt-0 mb-4 mb-md-0 btn bg-light text-muted custom-button-property w-100 w-md-auto'
                onClick={() => {
                  navigate('/rk/records-and-files')
                }}
              >
                {' '}
                {formatMessage({ id: 'View Records' })}
              </button>
            )}
          </div>

          <div className='sources-sync-card align-items-center mb-5'>
            <div className='d-flex gap-2 col-6'>
              <img
                src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-link.svg')}
                height={16}
                width={16}
                alt=''
              />
              <p className='text-muted m-0 font-size-12 mb-md-2 mb-2'>
                {formatMessage({ id: createdByDate + ` By ` + createdByEmail })}
              </p>
            </div>

            {attachedSourceEmail && (
              <div className='d-flex gap-2 col-6'>
                <img
                  src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-profile.svg')}
                  alt='profile'
                  width={16}
                  height={16}
                />
                <p className='text-muted m-0 font-size-12 mb-md-2 mb-2'>{attachedSourceEmail}</p>
              </div>
            )}
          </div>

          {totalFiles === 0 || noOfSyncFiles === 0 ? (
            <>
              {isRetry && !isPlanLimitExceeded ? (
                <div className='w-100 bg-e25 p-2 text-danger rounded-1'>
                  Something went wrong. Please retry syncing.
                </div>
              ) : isPlanLimitExceeded ? (
                <div className='w-100 bg-e25 p-2 text-danger rounded-1'>
                  {formatMessage({ id: 'Storage or File limit exceeded. Cannot process further.' })}{' '}
                  <Link to='/setting/billing-invoice?tab=billing'>
                    {formatMessage({ id: 'Please upgrade your plan' })}
                  </Link>
                </div>
              ) : (
                <div className=''>
                  <p className='text-primary m-0 font-size-12'>
                    {formatMessage({
                      id: 'Syncing Storage ... Please wait a while untill storage gets synced fully',
                    })}
                  </p>
                  <Lottie
                    className='w-100' // Use Bootstrap classes for full width and height
                    loop
                    animationData={animationData} // Pass the Lottie JSON file
                    style={{
                      width: '100%', // Full width
                      height: 'auto', // Increase height as needed
                      maxWidth: '100%', // Ensure it doesn't overflow
                      margin: '0 auto', // Center the animation horizontally
                      fill: '#4776E6',
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              {noOfSyncFiles !== totalFiles && (
                <>
                  {isRetry && !isPlanLimitExceeded ? (
                    <div className='w-100 bg-e25 p-2 text-danger rounded-1'>
                      {formatMessage({ id: 'Something went wrong. Please retry syncing.' })}
                    </div>
                  ) : isPlanLimitExceeded ? (
                    <div className='w-100 bg-e25 p-2 text-danger rounded-1'>
                      {formatMessage({ id: 'File limit exceeded. Cannot process further.' })}{' '}
                      <Link to='/setting/billing-invoice?tab=billing'>
                        {formatMessage({ id: 'Please upgrade your plan' })}
                      </Link>
                    </div>
                  ) : (
                    <div className=''>
                      <p className='text-primary m-0 font-size-12 mb-2'>
                        {formatMessage({
                          id: 'Syncing Storage ... Please wait a while untill storage gets synced fully',
                        })}
                      </p>
                      <ProgressBar
                        now={parseInt(((noOfSyncFiles / totalFiles) * 100).toFixed(2))}
                        variant='info'
                        className='mb-4'
                      />
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteSource}
        deleteLoading={deleteLoading}
        header={`Delete ${title}`}
        paragraph='Are you sure you want to delete this source?'
      />
    </>
  )
}

export default AddedStorageCard
